import { useMemo } from 'react';
export const useFindQueue = (payload, extraData) => {
    const { queues } = extraData;
    const { value: queueId } = payload !== null && payload !== void 0 ? payload : {};
    return useMemo(() => queues.find((queue) => queue.id === queueId), [queueId, queues]);
};
